import styled, { css } from 'styled-components'

export const SC_ResourceList = styled.div.attrs(props => ({

}))`
	border: 1px solid ${props => props.theme.cardBorderColor};
	border-radius: ${props => props.theme.borderRadius};
`

export const SC_ResourceBreadcrumbs = styled.div.attrs(props => ({

}))`
	background: ${props => props.theme.cardBorderColor};
	padding-left: ${props => props.theme.spacer};
	padding-right: ${props => props.theme.spacer};
	p {
		margin: 0;
	}

	.btn {
		position: relative;

		&:not(.text-muted):before {
			display: block;
			content: '/';
			right: -11px;
			position: absolute;
			font-weight: normal;
		}
	}
`

export const SC_ResourceActionBar = styled.div.attrs(props => ({

}))`
	// background: ${props => props.theme.gray100};
	// padding-left: ${props => props.theme.gridGutterWidth};
	padding: ${props => props.theme.spacer} ${props => props.theme.spacer};
	
	p {
		margin: 0;
	}

	.alert {
		margin: ${props => props.theme.spacer} 0 0 0;
	}
`

export const SC_Resource = styled.div.attrs(props => ({

}))`
	padding-left: ${props => props.theme.gridGutterWidth};
	padding-right: ${props => props.theme.gridGutterWidth};
	border-top: 1px solid ${props => props.theme.cardBorderColor};
	&:first-of-type {
		border-top: none;
	}
	p {
		margin: 0;
	}

	.btn-link {
		line-height: 1.2;

		.small {
			display: inline-block;
			line-height: 1;
		}
	}
`

export const SC_Folder = styled.div.attrs(props => ({

}))`
	padding-left: ${props => props.theme.gridGutterWidth};
	padding-right: ${props => props.theme.gridGutterWidth};
	border-top: 1px solid ${props => props.theme.cardBorderColor};
	&:first-of-type {
		border-top: none;
	}
	p {
		margin: 0;
	}
`

export const SC_IconContainer = styled.div.attrs(props => ({

}))`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 40px;
	height: 70px;
`